// TODO: move FourTenError implementation to CannedError
export { FourTenError as CannedError } from '../FourTenError';
export type { FourTenErrorProps as CannedErrorProps } from '../FourTenError';
